var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.375C15.0355 16.375 15.875 15.5355 15.875 14.5C15.875 13.4645 15.0355 12.625 14 12.625C12.9645 12.625 12.125 13.4645 12.125 14.5C12.125 15.5355 12.9645 16.375 14 16.375Z",
    fill: "#8493B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.625C15.0355 22.625 15.875 21.7855 15.875 20.75C15.875 19.7145 15.0355 18.875 14 18.875C12.9645 18.875 12.125 19.7145 12.125 20.75C12.125 21.7855 12.9645 22.625 14 22.625Z",
    fill: "#8493B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.125C15.0355 10.125 15.875 9.28553 15.875 8.25C15.875 7.21447 15.0355 6.375 14 6.375C12.9645 6.375 12.125 7.21447 12.125 8.25C12.125 9.28553 12.9645 10.125 14 10.125Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action_icon.6536424344f15d93aa34318a97475e8a.svg";
export { ForwardRef as ReactComponent };